export const MODALS = Object.freeze({
  PENDING_REQUESTS: "pendingRequests",
  CHANGE_FLIGHTS: "changeFlights",
  INSURANCE: "insurance",
  PAYMENT: "payment",
  BOOKING_CANCELLATION: "bookingCancellation",
  BOOKING_CANCELLATION_REQUEST: "bookingCancellationRequest",
  PASSENGERS: "passengers",
  BAGS: "bags",
  REFUND: "refund",
  SEATING: "seating",
  FAST_REFUND: "fastRefund",
  PASSENGER_EDIT: "passenger_edit",
  SPORTS_EQUIPMENT: "sports_equipment",
  MUSICAL_EQUIPMENT: "musical_equipment",
  SPECIAL_ASSISTANCE: "special_assistance",
  PETS: "travelling_with_pets",
  PENDING_REFUNDS: "pendingRefunds",
  REFUND_STATUSES: "refundStatuses",
  SCHEDULE_CHANGE: "scheduleChange",
  ORDER_SUCCESS: "genericPaymentThankYou",
  JOURNEY_CHANGE_UNAVAILABLE: "journeyChangeUnavailable",
  INVOICES: "invoices",
  US_INSURANCE_SUCCESS: "usInsuranceSuccess",
  US_INSURANCE_ERROR: "usInsuranceError",
  PENDING_CHANGES_ERROR: "pendingChangesError",
  CHECK_IN_HEALTH_DECLARATION: "checkInHealthDeclaration",
  CHECK_IN_DOCUMENTS: "checkInDocuments",
  OOP_KIWI_OFFER: "oopKiwiOffer",
  ALTERNATIVE_METHOD_OFFER: "alternativeMethodOffer",
  PROACTIVE_REFUND_OFFER: "proactiveRefundOffer",
  REFUND_DETAILS: "refundDetails",
  ADDITIONAL_SERVICE_NOT_YET_AVAILABLE: "additionalServiceNotYetAvailable",
  ADDITIONAL_SERVICE_TOO_LATE_TO_ORDER: "additionalServiceTooLateToOrder",
  ADDITIONAL_SERVICE_ACTIVE_SCHEDULE_CHANGE: "additionalServiceActiveScheduleChange",
  ADDITIONAL_SERVICE_ITINERARY_CHANGE_IN_PROGRESS: "additionalServiceItineraryChangeInProgress",
  ADDITIONAL_SERVICE_HIDDEN_CITY: "additionalServiceHiddenCity",
  ADDITIONAL_SERVICE_NO_CHECKED_BAGGAGE: "additionalServiceNoCheckedBaggage",
  ADDITIONAL_SERVICE_UNAVAILABLE_CONTACT_CS: "additionalServiceUnavailableContactCs",
  ADDITIONAL_SERVICE_UNAVAILABLE_DEEPLINK_FALLBACK: "additionalServiceUnavailableDeeplinkFallback",
  BOOKING_STATUS_WAITING: "bookingStatusWaiting",
  BOOKING_STATUS_DELAYED: "bookingStatusDelayed",
  PASSENGER_DETAILS: "passengerDetails",
  VOLUNTARY_CHANGE_NOT_AVAILABLE: "voluntaryChangeNotAvailable",
  ADDITIONAL_SERVICE_DEADLINES: "additionalServiceDeadlines",
  DISRUPTION_PROTECTION_UPSELL: "disruptionProtectionUpsell",
  DOCUMENT_VERIFICATION: "documentVerification",
  ITINERARY_DETAILS: "itineraryDetails",
  FARE_CONDITIONS: "fareConditions",
  FARE_CONDITIONS_MANUAL_REBOOKING: "fareConditionsManualRebooking",
  INSTANT_CREDIT: "instantCredit",
  ASSISTED_REFUND: "assistedRefund",
  MEDICAL: "medical",
  DEATH: "death",
  FARE_TYPE_REFUND: "fareTypeRefund",
  AUTOMATIC_VOID: "automaticVoid",
  EXPENSE_REFUND: "expenseRefund",
  INVOLUNTARY_ASSISTED_REFUND: "involuntaryAssistedRefund",
  DISRUPTION_REFUND: "disruptionRefund",
})

export type Modals = typeof MODALS[keyof typeof MODALS]
